import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconMountainStyle0 = cosmosIconCss;

const CosmosIconMountain$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconMountain extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'd87bf86d09c25e18b6c40286e4a7c8f7eb1a29fe', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'd89d4621fd871083ac1ea1d04d27e26c0d049ab5', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '19546d008dba01ab042b89fa9166d4020a28e4b8', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M7.93 5.517a1.31 1.31 0 0 1-1.219.803 1.3 1.3 0 0 1-1.3-1.299 1.31 1.31 0 1 1 2.52.496ZM9.3 13.1l3.865-5.497 5.292 7.527h-7.73l1.106 1.573-5.23-7.437a.524.524 0 0 0-.857 0l-4.649 6.61a.524.524 0 0 0 .429.827h18.949a.524.524 0 0 0 .429-.826L13.593 5.48a.524.524 0 0 0-.858 0l-4.397 6.254.96 1.367Zm-3.126-1.71-2.63 3.74h5.26l-2.63-3.74Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconMountainStyle0; }
}, [1, "cosmos-icon-mountain", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-mountain"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-mountain":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconMountain$1);
            }
            break;
    } });
}

const CosmosIconMountain = CosmosIconMountain$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconMountain, defineCustomElement };
